import React from 'react'

import {
  FieldSpec,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  shipment: {
    id: 'shipment',
    label: 'Shipment',
    ordering: 'shipment__carrier__name,shipment__tracking_number',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  unit: { id: 'unit.guid', label: 'Unit', ordering: 'unit__xid', renderer: ValueField },
  product: { id: 'unit.product.name', label: 'Product', ordering: 'unit__product__name', renderer: ValueField },
}

export const FreightShipmentBarcodedUnitListTable = (props: ListTableProps) => {
  const { paginator, fields, title } = props

  return (
    <>
      <PaginatedTable
        title={title ? title : 'Units (Barcoded) in Active Freight Shipments'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
